import {type Tokens} from 'marked';

import {type Renderer} from '@time-webkit/marked';

import RemoveMarkdown from 'utils/markdown/remove_markdown';
import * as Emoticons from 'utils/emoticons';
import {doFormatText, type TextFormattingOptions} from 'utils/text_formatting';

export class PostQuoteMarkdown extends RemoveMarkdown {
    constructor(
        private nativeRenderer: Renderer,
        private textFormattingOptions: TextFormattingOptions,
    ) {
        super();
    }

    del({tokens}: Tokens.Del): string {
        return this.nativeRenderer.del.call(this, {tokens} as Tokens.Del);
    }

    text(token: Tokens.Text): string {
        const text = super.text(token);
        return doFormatText(text, this.textFormattingOptions);
    }

    public emoji(token: Tokens.Generic) {
        const emoji = token.isUnicode ? (
            `<span class="emoticon emoticon--unicode">${token.raw}</span>`
        ) : Emoticons.renderEmoji(token.text.replaceAll(':', ''), token.raw);

        if (!this.textFormattingOptions.singleline && token?.isSingle) {
            return `<span class='all-emoji'>${emoji}</span>`;
        }

        return emoji;
    }
}
